import type { ReactElement } from 'react'

import { Seo } from '@ui/components/seo'
import { HeroBasic } from '@ui/hero'
import { MarketingLayout } from '@ui/layout/MarketingLayout'
import {
  MainBlockAboutEmpowering,
  MainBlockAboutMeetTheTeam,
} from '@ui/main-blocks'

import { MainBlockAboutHeadshotsImage } from '@website/components/images'

const title = 'About Us, Our Mission & Who We Are'
const description =
  'ATM.com is an all-in-one finance app that empowers users with ATM Instant Cash™, providing quick access to cash advances, budgeting tools, financial management support, and a variety of ways to earn extra money through games, surveys, and cashback rewards.'

export function Index() {
  return (
    <>
      <Seo title={title} description={description} />
      <div className="relative bg-[url('/img/our-mission-bg.svg')] bg-cover bg-center pt-[120px]">
        <HeroBasic
          className="!bg-transparent"
          title={
            <span className="font-display tracking-wider text-[#0a2d4a]">
              OUR MISSION
            </span>
          }
          description="We believe that everyone deserves financial peace of mind."
        />
      </div>
      <MainBlockAboutEmpowering />
      <MainBlockAboutMeetTheTeam
        HeadshotComponent={MainBlockAboutHeadshotsImage}
      />
    </>
  )
}

Index.getLayout = (page: ReactElement) => (
  <MarketingLayout bg="light-blue" chin="white" mainClassName="-mt-[120px]">
    {page}
  </MarketingLayout>
)

export default Index
